import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilesHistory = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 21,
	viewBox: "0 0 21 21",
	width: 21,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: .6,
		transform: "translate(3 2)",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "m14.5 12.5v-7l-5-5h-5c-1.1045695 0-2 .8954305-2 2v10c0 1.1045695.8954305 2 2 2h8c1.1045695 0 2-.8954305 2-2z" }),
			/* @__PURE__ */ _jsx("path", { d: "m8.5 4.5v4h3" }),
			/* @__PURE__ */ _jsx("path", { d: "m2.5 2.5c-1.1045695 0-2 .8954305-2 2v10c0 1.1045695.8954305 2 2 2h8c1.1045695 0 2-.8954305 2-2" })
		]
	})
});
export default SvgFilesHistory;
